module.exports = __webpack_public_path__ + "0af5d249/img/menu-icon.5f8facae.svg";